let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lK8aI")).then(() => parcelRequire('5O8im'));